import "./style.css";

import AudioTrackIcon from "../../../../../icons/AudioTrack";

interface IThumbnailProps {
  thumbnail: string;
}

const Thumbnail: React.FC<IThumbnailProps> = ({ thumbnail }) => {
  return (
    <>
      {thumbnail ? (
        <div>
          <img src={thumbnail} alt="Capa" className="audio-thumbnail" />
        </div>
      ) : (
        <div className="audio-icon">
          <AudioTrackIcon />
        </div>
      )}
    </>
  );
};

export default Thumbnail;
